import { AuthApiService } from '@revenuewell/logic-http';
import { NavigationService } from '@revenuewell/logic-navigation';
import { OidcService } from '@revenuewell/logic-oidc';

export default class FeatureFlagService extends AuthApiService {
    private config: any;

    constructor(config: any, oidcService: OidcService) {
        super(oidcService, new NavigationService());
        this.config = config;
    }

    getFeatureFlags = async (locationId: number): Promise<string[]> => {
        const url = `${this.config.featureFlags.apiUrl}/locations/${locationId}/feature-flags`;
        const response = await this.authFetch(url, { method: 'GET' }, { ttlSeconds: 60 });
        return response.json();
    };
}
